require('es6-promise').polyfill();
require('isomorphic-fetch');

function fetchAsync(fullUrl, action) {
  return dispatch => {
    dispatch({
      type: `${action}_REQUEST`
    });
    const config = {
      headers: new Headers({'Content-Type': 'application/json'}),
      credentials: 'same-origin'
    };
    return fetch(fullUrl, config)
      .then(response => response.json())
      .then(data => dispatch({
        type: `${action}_SUCCESS`,
        data
      }))
      .catch(error => dispatch({
        type: `${action}_ERROR`,
        error
      }));
  };
}

export function fetchPosts(params) {
  const tag = params.tag !== '/' ? params.tag : 'main';
  const search = params.filter;
  const page = typeof params.pageIndex === 'undefined' ? 1 : params.pageIndex;
  return fetchAsync(`${params.baseURL}/_api/posts?tag=${tag}&search=${search}&page=${page}&from=${params.from}&to=${params.to}`, 'FETCH_POSTS');
}

export function fetchPost(params) {
  const id = params.id;
  return fetchAsync(`${params.baseURL}/_api/post/${id}`, 'FETCH_POST');
}

export function fetchPostsByDate(params) {
  const tag = params.tag;
  return fetchAsync(`${params.baseURL}/_api/postsByDate?tag=${tag}&from=${params.startDate}&to=${params.endDate}`, 'FETCH_POSTS');
}

export function subscribeUser(params) {
  return fetchAsync(`${params.baseURL}/_api/subscribeNewUser`, 'SUBSCRIBE');
}

export function toggleDatePickerOpenState(open) {
  return {
    type: 'SET_OPEN_TOOGLE_STATE',
    open
  };
}

export function toggleDatePickerActiveState(active) {
  return {
    type: 'SET_ACTIVE_TOOGLE_STATE',
    active
  };
}

export function datePickerStartDate(startDate) {
  return {
    type: 'SET_START_DATE_STATE',
    startDate
  };
}

export function datePickerEndDate(endDate) {
  return {
    type: 'SET_END_DATE_STATE',
    endDate
  };
}

export function datePickerDatesRange(dateRange) {
  return {
    type: 'SET_DATES_RANGE_STATE',
    dateRange
  };
}

export function search(filter) {
  return {
    type: 'SEARCH_SUCCESS',
    filter
  };
}

export function subscribedComplete(params) {
  return {
    type: 'SUBSCRIBE_COMPLETE',
    params
  };
}

export function subscribedFail(params) {
  return {
    type: 'SUBSCRIBE_ERROR',
    params
  };
}



// WEBPACK FOOTER //
// ./actions/index.js